module.exports = __webpack_public_path__ + "media/favicon/favicon-32x32-37270c3f2ca09f1ece7f75822dd49e33.png";